(function () {
  function initPdpParity(page) {
    if (!page || page.getAttribute('data-zs-parity-ready') === 'true') return;
    page.setAttribute('data-zs-parity-ready', 'true');

    var formId = page.getAttribute('data-product-form-id');
    var form = formId ? document.getElementById(formId) : null;
    var price = page.querySelector('[data-zs-live-price]');
    var availability = page.querySelector('[data-zs-live-availability]');
    var buyNowButton = page.querySelector('[data-zs-buy-now]');
    var addButton = page.querySelector('[data-zs-main-add]');
    var quantityInput = form ? form.querySelector('input[name="quantity"]') : null;
    var mobileBar = page.querySelector('[data-zs-mobile-buybar]');
    var mobilePrice = page.querySelector('[data-zs-mobile-price]');
    var mobileAdd = page.querySelector('[data-zs-mobile-add]');
    var purchase = page.querySelector('[data-zs-purchase-card]');
    var purchaseStop = page.querySelector('[data-zs-purchase-stop]');
    var commerce = page.querySelector('.zs-pdp-parity__commerce');
    var footer = document.querySelector('footer');
    var floatingSupport = page.querySelector('[data-zs-floating-support]');
    var tabs = page.querySelector('[data-zs-pdp-tabs]');
    var siteHeader = document.querySelector('.zs-header, .zt-header, header[role="banner"]');

    function updateBuyNowLink(variantInput) {
      if (!buyNowButton || !form) return;
      var input = variantInput || form.querySelector('input[name="id"]:checked') || form.querySelector('input[name="id"]');
      var variantId = input ? input.value : '';
      var available = input && input.getAttribute('data-available') === 'true';
      var quantity = quantityInput ? parseInt(quantityInput.value || '1', 10) : 1;
      var permalinkRoot = buyNowButton.getAttribute('data-cart-permalink-root') || '/cart/';
      quantity = Math.max(1, Number.isFinite(quantity) ? quantity : 1);
      if (available && variantId) {
        buyNowButton.setAttribute('href', permalinkRoot + encodeURIComponent(variantId) + ':' + quantity);
        buyNowButton.removeAttribute('aria-disabled');
        buyNowButton.removeAttribute('tabindex');
        buyNowButton.classList.remove('is-disabled');
        return;
      }
      buyNowButton.removeAttribute('href');
      buyNowButton.setAttribute('aria-disabled', 'true');
      buyNowButton.setAttribute('tabindex', '-1');
      buyNowButton.classList.add('is-disabled');
    }

    function setVariant(input) {
      if (!input) return;
      var available = input.getAttribute('data-available') === 'true';
      var label = input.getAttribute('data-price-label');
      var rawPrice = parseInt(input.getAttribute('data-price') || '0', 10);
      var rawCompare = parseInt(input.getAttribute('data-compare') || '0', 10);
      var compareLabel = input.getAttribute('data-compare-label');
      var savingsLabel = input.getAttribute('data-savings-label');
      var discountPercent = input.getAttribute('data-discount-percent');
      var isSale = rawCompare > rawPrice && rawPrice > 0;
      if (price && label) {
        var currentPrice = price.querySelector('[data-zs-current-price]');
        var comparePrice = price.querySelector('[data-zs-compare-price]');
        var promoBadge = price.querySelector('[data-zs-promo-badge]');
        var priceSaving = price.querySelector('[data-zs-price-saving]');
        var savingAmount = price.querySelector('[data-zs-saving-amount]');
        var discountAmount = price.querySelector('[data-zs-discount-percent]');
        if (currentPrice) currentPrice.textContent = label;
        else price.textContent = label;
        if (comparePrice) {
          comparePrice.textContent = compareLabel || '';
          comparePrice.hidden = !isSale;
        }
        if (promoBadge) promoBadge.hidden = !isSale;
        if (priceSaving) priceSaving.hidden = !isSale;
        if (savingAmount) savingAmount.textContent = savingsLabel || '';
        if (discountAmount) discountAmount.textContent = isSale ? ' • ' + discountPercent + '% Off' : '';
      }
      if (mobilePrice && label) mobilePrice.textContent = label;
      if (availability) availability.textContent = available ? 'In Stock' : 'Contact Us for Availability';
      updateBuyNowLink(input);
      if (addButton) addButton.disabled = !available;
      if (mobileAdd) mobileAdd.disabled = !available;
    }

    page.querySelectorAll('[data-zs-variant-option]').forEach(function (input) {
      input.addEventListener('change', function () { setVariant(input); });
      if (input.checked) setVariant(input);
    });

    if (buyNowButton && form) {
      updateBuyNowLink();
      if (quantityInput) {
        quantityInput.addEventListener('input', function () { updateBuyNowLink(); });
        quantityInput.addEventListener('change', function () { updateBuyNowLink(); });
      }
      page.querySelectorAll('[data-zs-qty]').forEach(function (button) {
        button.addEventListener('click', function () {
          window.requestAnimationFrame(function () { updateBuyNowLink(); });
        });
      });
    }

    if (mobileAdd && addButton) {
      mobileAdd.addEventListener('click', function () {
        if (!addButton.disabled) addButton.click();
      });
    }

    function previewOffset() {
      var preview = document.querySelector('iframe[src*="preview_bar"], iframe[id*="preview-bar"], #preview-bar-iframe, #PBarNextFrameWrapper');
      var height = preview ? Math.max(0, preview.getBoundingClientRect().height) : 0;
      page.style.setProperty('--zs-preview-offset', height + 'px');
    }

    function updateStickyOffsets() {
      var headerHeight = 0;
      if (siteHeader) {
        var headerStyle = window.getComputedStyle(siteHeader);
        var headerBox = siteHeader.getBoundingClientRect();
        if ((headerStyle.position === 'sticky' || headerStyle.position === 'fixed') && headerBox.bottom > 0) {
          headerHeight = Math.max(0, Math.ceil(headerBox.bottom - Math.max(0, headerBox.top)));
        }
      }
      var tabsHeight = tabs ? Math.ceil(tabs.getBoundingClientRect().height) : 0;
      page.style.setProperty('--zs-pdp-sticky-header-height', headerHeight + 'px');
      page.style.setProperty('--zs-pdp-tabs-height', tabsHeight + 'px');
      page.style.setProperty('--zs-pdp-anchor-offset', (headerHeight + tabsHeight + 14) + 'px');
    }

    function updateMobileBuybarHeight() {
      if (!mobileBar || mobileBar.hidden) {
        page.style.setProperty('--zs-pdp-mobile-buybar-height', '0px');
        document.documentElement.style.setProperty('--zs-shopify-chat-translate-y', '-4px');
        return;
      }
      var mobileBarHeight = Math.ceil(mobileBar.getBoundingClientRect().height);
      page.style.setProperty('--zs-pdp-mobile-buybar-height', mobileBarHeight + 'px');
      var inbox = document.querySelector('shopify-chat');
      var inboxActivator = inbox && inbox.shadowRoot ? inbox.shadowRoot.querySelector('[part="activator"]') : null;
      if (!inboxActivator) return;
      var rootStyle = getComputedStyle(document.documentElement);
      var currentOffset = parseFloat(rootStyle.getPropertyValue('--zs-shopify-chat-translate-y'));
      if (!Number.isFinite(currentOffset)) currentOffset = -4;
      var activatorBox = inboxActivator.getBoundingClientRect();
      var mobileBarBox = mobileBar.getBoundingClientRect();
      var normalActivatorBottom = activatorBox.bottom + (-4 - currentOffset);
      var nextOffset = -4 + (mobileBarBox.top - 14 - normalActivatorBottom);
      document.documentElement.style.setProperty('--zs-shopify-chat-translate-y', Math.min(-4, Math.round(nextOffset)) + 'px');
    }

    function mobileBarState() {
      if (!mobileBar || !purchase || !window.matchMedia('(max-width: 749px)').matches) {
        if (mobileBar) mobileBar.hidden = true;
        document.documentElement.classList.remove('zs-pdp-mobile-buybar-visible');
        document.documentElement.style.setProperty('--zs-shopify-chat-translate-y', '-4px');
        return;
      }
      var purchaseBox = purchase.getBoundingClientRect();
      var footerBox = footer ? footer.getBoundingClientRect() : null;
      var pastPurchase = purchaseBox.bottom < 0;
      var footerVisible = footerBox && footerBox.top < window.innerHeight + 24;
      mobileBar.hidden = !pastPurchase || footerVisible;
      document.documentElement.classList.toggle('zs-pdp-mobile-buybar-visible', !mobileBar.hidden);
      updateMobileBuybarHeight();
      if (floatingSupport) {
        floatingSupport.classList.toggle('has-mobile-buybar', !mobileBar.hidden);
        floatingSupport.classList.toggle('is-footer-visible', Boolean(footerVisible));
      }
    }

    function supportState() {
      if (!floatingSupport) return;
      var footerBox = footer ? footer.getBoundingClientRect() : null;
      var footerVisible = footerBox && footerBox.top < window.innerHeight + 24;
      floatingSupport.classList.toggle('is-footer-visible', Boolean(footerVisible));

      floatingSupport.classList.remove('is-content-overlap');
      var launcherBox = floatingSupport.getBoundingClientRect();
      var purchaseBox = purchase ? purchase.getBoundingClientRect() : null;
      var overlapsPurchase = purchaseBox && purchaseBox.bottom > launcherBox.top && purchaseBox.top < launcherBox.bottom && purchaseBox.right > launcherBox.left && purchaseBox.left < launcherBox.right;
      floatingSupport.classList.toggle('is-content-overlap', Boolean(overlapsPurchase));
    }

    function inboxOffset() {
      if (!floatingSupport) return;
      var inbox = document.querySelector('shopify-chat, [data-shopify-chat], #ShopifyChat, iframe[title*="chat" i], iframe[src*="shopify-chat"]');
      var inboxActivator = inbox && inbox.shadowRoot ? inbox.shadowRoot.querySelector('[part="activator"]') : null;
      page.style.setProperty('--zs-contact-launcher-right', '22px');
      floatingSupport.classList.toggle('is-inbox-present', Boolean(inboxActivator));
      updateMobileBuybarHeight();
    }

    function desktopPurchaseState() {
      if (!purchase || !purchaseStop || !commerce || !window.matchMedia('(min-width: 1024px)').matches) {
        if (purchase) {
          purchase.classList.remove('is-released');
          purchase.style.removeProperty('--zs-purchase-release-top');
        }
        return;
      }

      purchase.classList.remove('is-released');
      var stopTop = purchaseStop.getBoundingClientRect().top + window.scrollY;
      var commerceTop = commerce.getBoundingClientRect().top + window.scrollY;
      var releaseTop = Math.max(0, stopTop - commerceTop - purchase.offsetHeight - 18);
      var shouldRelease = window.scrollY + 18 >= commerceTop + releaseTop;
      purchase.style.setProperty('--zs-purchase-release-top', releaseTop + 'px');
      purchase.classList.toggle('is-released', shouldRelease);
    }

    var scheduled = false;
    function onScroll() {
      if (scheduled) return;
      scheduled = true;
      window.requestAnimationFrame(function () {
        scheduled = false;
        updateStickyOffsets();
        mobileBarState();
        desktopPurchaseState();
        supportState();
        syncActiveTab();
      });
    }

    previewOffset();
    mobileBarState();
    desktopPurchaseState();
    supportState();
    inboxOffset();
    window.setTimeout(inboxOffset, 300);
    window.setTimeout(inboxOffset, 1200);
    window.setTimeout(inboxOffset, 3500);
    updateStickyOffsets();
    window.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', function () { previewOffset(); updateStickyOffsets(); mobileBarState(); desktopPurchaseState(); supportState(); inboxOffset(); });
    window.addEventListener('orientationchange', function () {
      window.setTimeout(function () { previewOffset(); updateStickyOffsets(); mobileBarState(); supportState(); }, 120);
    });

    if (floatingSupport && window.MutationObserver) {
      var inboxObserver = new MutationObserver(inboxOffset);
      inboxObserver.observe(document.body, { childList: true, subtree: true });
    }

    if (siteHeader && window.MutationObserver) {
      var headerObserver = new MutationObserver(function () {
        window.requestAnimationFrame(function () { updateStickyOffsets(); supportState(); });
      });
      headerObserver.observe(siteHeader, { attributes: true, childList: true, subtree: true, attributeFilter: ['class', 'hidden', 'aria-expanded', 'style'] });
    }

    var activeDialogTrigger = null;
    function focusableElements(dialog) {
      return Array.prototype.slice.call(dialog.querySelectorAll('a[href], button:not([disabled]), input:not([disabled]), select:not([disabled]), textarea:not([disabled]), [tabindex]:not([tabindex="-1"])')).filter(function (element) {
        return element.offsetParent !== null;
      });
    }

    page.querySelectorAll('[data-zs-dialog-open]').forEach(function (trigger) {
      trigger.addEventListener('click', function () {
        var dialog = document.getElementById(trigger.getAttribute('data-zs-dialog-open'));
        if (!dialog || typeof dialog.showModal !== 'function') return;
        activeDialogTrigger = trigger;
        dialog.showModal();
        document.documentElement.classList.add('zs-pdp-dialog-open');
        document.body.classList.add('zs-pdp-dialog-open');
        window.requestAnimationFrame(function () {
          var first = focusableElements(dialog)[0];
          if (first) first.focus();
        });
      });
    });

    page.querySelectorAll('[data-zs-dialog]').forEach(function (dialog) {
      var closeButton = dialog.querySelector('[data-zs-dialog-close]');
      if (closeButton) closeButton.addEventListener('click', function () { dialog.close(); });
      dialog.addEventListener('click', function (event) {
        if (event.target === dialog) dialog.close();
      });
      dialog.addEventListener('cancel', function (event) {
        event.preventDefault();
        dialog.close();
      });
      dialog.addEventListener('keydown', function (event) {
        if (event.key !== 'Tab') return;
        var focusable = focusableElements(dialog);
        if (!focusable.length) return;
        var first = focusable[0];
        var last = focusable[focusable.length - 1];
        if (event.shiftKey && document.activeElement === first) {
          event.preventDefault();
          last.focus();
        } else if (!event.shiftKey && document.activeElement === last) {
          event.preventDefault();
          first.focus();
        }
      });
      dialog.addEventListener('close', function () {
        document.documentElement.classList.remove('zs-pdp-dialog-open');
        document.body.classList.remove('zs-pdp-dialog-open');
        if (activeDialogTrigger) activeDialogTrigger.focus();
        activeDialogTrigger = null;
      });
    });

    var tabLinks = tabs ? Array.prototype.slice.call(tabs.querySelectorAll('a[href^="#"]')) : [];
    var tabSections = tabLinks.map(function (link) {
      return document.getElementById(link.getAttribute('href').slice(1));
    }).filter(Boolean);

    function revealActiveTab(link) {
      if (!tabs || !link) return;
      var nextLeft = link.offsetLeft - ((tabs.clientWidth - link.offsetWidth) / 2);
      tabs.scrollTo({ left: Math.max(0, nextLeft), behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth' });
    }

    function syncHash(id) {
      var nextHash = '#' + id;
      if (window.location.hash === nextHash) return;
      if (window.history && window.history.replaceState) {
        window.history.replaceState(null, '', nextHash);
      } else {
        window.location.hash = nextHash;
      }
    }

    function setActiveTab(id, reveal, updateHash) {
      var activeLink = null;
      tabLinks.forEach(function (link) {
        var isActive = link.getAttribute('href') === '#' + id;
        link.classList.toggle('is-active', isActive);
        if (isActive) {
          link.setAttribute('aria-current', 'true');
          activeLink = link;
        } else {
          link.removeAttribute('aria-current');
        }
      });
      if (reveal && activeLink) revealActiveTab(activeLink);
      if (activeLink && updateHash) syncHash(id);
    }

    function scrollToTabSection(target, behavior) {
      if (!target) return;
      updateStickyOffsets();
      var offset = parseFloat(window.getComputedStyle(page).getPropertyValue('--zs-pdp-anchor-offset')) || 76;
      window.scrollTo({
        top: Math.max(0, target.getBoundingClientRect().top + window.scrollY - offset),
        behavior: behavior
      });
    }

    function syncActiveTab() {
      if (!tabs || !tabSections.length) return;
      var threshold = parseFloat(window.getComputedStyle(page).getPropertyValue('--zs-pdp-anchor-offset')) || 76;
      var activationLine = Math.max(threshold + 12, Math.min(window.innerHeight * 0.35, 280));
      var activeSection = tabSections[0];
      var documentHeight = Math.max(document.documentElement.scrollHeight, document.body.scrollHeight);
      var atPageEnd = window.scrollY + window.innerHeight >= documentHeight - 2;
      if (atPageEnd) {
        activeSection = tabSections[tabSections.length - 1];
      } else {
        tabSections.forEach(function (section) {
          if (section.getBoundingClientRect().top <= activationLine) activeSection = section;
        });
      }
      setActiveTab(activeSection.id, false, false);
    }

    if (tabs) {
      tabLinks.forEach(function (link) {
        link.addEventListener('click', function (event) {
          var target = document.getElementById(link.getAttribute('href').slice(1));
          if (!target) return;
          event.preventDefault();
          var behavior = window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth';
          setActiveTab(target.id, true, true);
          scrollToTabSection(target, behavior);
        });
      });
      window.addEventListener('hashchange', function () {
        var target = document.getElementById(window.location.hash.slice(1));
        if (!target || tabSections.indexOf(target) === -1) return;
        setActiveTab(target.id, true, false);
        scrollToTabSection(target, 'auto');
      });
      updateStickyOffsets();
      var initialTarget = document.getElementById(window.location.hash.slice(1));
      if (initialTarget && tabSections.indexOf(initialTarget) !== -1) {
        setActiveTab(initialTarget.id, true, false);
        window.requestAnimationFrame(function () { scrollToTabSection(initialTarget, 'auto'); });
      } else {
        syncActiveTab();
      }

      page.querySelectorAll('.zs-pdp-parity__details-hub a[href^="#"]').forEach(function (link) {
        link.addEventListener('click', function (event) {
          var target = document.getElementById(link.getAttribute('href').slice(1));
          if (!target || tabSections.indexOf(target) === -1) return;
          event.preventDefault();
          var behavior = window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth';
          setActiveTab(target.id, true, true);
          scrollToTabSection(target, behavior);
        });
      });
    }

    var gallery = page.querySelector('[data-zs-gallery]');
    if (gallery) {
      var thumbs = Array.prototype.slice.call(gallery.querySelectorAll('[data-zs-thumb]'));
      thumbs.forEach(function (thumb, index) {
        thumb.addEventListener('keydown', function (event) {
          var next = index;
          if (event.key === 'ArrowDown' || event.key === 'ArrowRight') next = (index + 1) % thumbs.length;
          if (event.key === 'ArrowUp' || event.key === 'ArrowLeft') next = (index - 1 + thumbs.length) % thumbs.length;
          if (next === index) return;
          event.preventDefault();
          thumbs[next].focus();
          thumbs[next].click();
          thumbs[next].scrollIntoView({ block: 'nearest', inline: 'nearest' });
        });
      });

      var stage = gallery.querySelector('.zs-pdp-parity__media-stage');
      var startX = 0;
      if (stage) {
        stage.addEventListener('touchstart', function (event) {
          if (event.touches && event.touches.length === 1) startX = event.touches[0].clientX;
        }, { passive: true });
        stage.addEventListener('touchend', function (event) {
          if (!event.changedTouches || !event.changedTouches.length) return;
          var distance = event.changedTouches[0].clientX - startX;
          if (Math.abs(distance) < 48) return;
          var direction = distance > 0 ? -1 : 1;
          var inLightbox = Boolean(event.target.closest('[data-zs-lightbox]'));
          var controlSelector = inLightbox
            ? '[data-zs-lightbox] [data-zs-gallery-step="' + direction + '"][data-zs-gallery-images-only]'
            : '[data-zs-gallery-step="' + direction + '"]:not([data-zs-gallery-images-only])';
          var control = gallery.querySelector(controlSelector);
          if (control) control.click();
        }, { passive: true });
      }
    }
  }

  function initAll() {
    document.querySelectorAll('[data-zs-pdp-page]').forEach(initPdpParity);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll, { once: true });
  } else {
    initAll();
  }
})();
